import React from 'react'
import { Box, Skeleton, Paper, Stack, styled } from '@mui/material'

const BubbleContainer = styled(Paper)(({ theme }) => ({
  flex: 1,
  maxWidth: '400px',
  borderRadius: '20px 20px 20px 6px',
  padding: theme.spacing(2),
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#fff',
}))

const LoadingShimmer = React.memo(() => {
  return (
    <Box sx={{ px: 2, mb: 3 }}>
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Skeleton
          variant="circular"
          width={36}
          height={36}
          animation="wave"
          sx={{ flexShrink: 0 }}
        />

        <BubbleContainer elevation={0}>
          <Stack spacing={1}>
            <Skeleton variant="rounded" width="60%" height={12} animation="wave" />
            <Skeleton variant="rounded" width="100%" height={12} animation="wave" />
            <Skeleton variant="rounded" width="80%" height={12} animation="wave" />
          </Stack>
        </BubbleContainer>
      </Stack>
    </Box>
  )
})

LoadingShimmer.displayName = 'LoadingShimmer'

export default LoadingShimmer
